<app-header></app-header>

<div class="page-title-area page-title-style-two item-corona">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Coronavirus</li>
            </ul>
            <h2>Coronavirus</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <img src="assets/img/covid1.jpg" alt="image" class="floatImg">
                <h2>CE TREBUIE SĂ ȘTIȚI DESPRE NOUL CORONAVIRUS (Covid-19)</h2>
                <p><strong>10 elemente comportamentale care trebuiesc urmate:</strong></p>
                <p>1.Spălați-vă mâinile de multe ori;</p>
                <p>2.Evitați contactul cu persoane care sunt suspecte de infecții respiratorii acute;</p>
                <p>3.Nu vă atingeți ochii , nasul si gura cu mâinile;</p>
                <p>4.Acoperiți-vă gura și nasul daca stranutați sau tușiți;</p>
                <p>5.Nu luați medicamente antivirale si nici antibiotice decât în cazul în care va prescrie medicul;
                </p>
                <p>6.Curățați toate suprafețele cu dezinfectanți pe bază de clor sau alcool;</p>
                <p>7.Utilizați masca de protecție doar în cazul in care suspectați că sunteți bolnav sau în cazul în
                    care acordați asistență persoanelor bolnave;</p>
                <p>8.Produsele "MADE in CHINA" sau pachetele primite din China nu sunt periculoase;</p>
                <p>9.Sunați la 112 dacă aveți febră, tușiți sau v-ați întors din China sau zonele in carantina din
                    Europa de cel puțin 14 zile;</p>
                <p>10.Animalele de companie nu transmit coronavirus.</p>
                <p><strong>Spălați-vă mâinile de multe ori</strong></p>
                <p>Spălarea și dezinfectarea mâinilor sunt acțiuni decisive pentru a preveni infecția. Mâinile se
                    spală cu apă și săpun cel putin 20 de secunde. Daca nu exista apă și săpun, puteți folosi un
                    dezinfectant pentru mâini pe bază de alcool de 60%.</p>
                <p>Spălarea mâinilor elimina virusul.</p>
                <p><strong>Evitați contactul cu persoane care sunt suspecte de infecții respiratorii acute</strong>
                </p>
                <p>Mențineți distanța de cel puțin 1 metru între dumneavoastră și alte persoane, în special când
                    acestea tușesc, strănută sau au febră, deoarece picăturile de salivă pot transmite virusul de la
                    o distanță apropiată.</p>
                <p><strong>Nu vă atingeți ochii , nasul și gura cu mâinile</strong></p>
                <p>Virusul se transmite mai ales pe cale respiratorie, dar poate intra în corp prin ochi, nas și
                    gură, astfel eviați atingerea dacă nu v-ați spălat bine mâinile.</p>
                <p>Mâinile intră in contact cu suprafețele contaminate de virus răspândidu-se in tot corpul .</p>
                <p><strong>Acoperiți-vă gura și nasul dacă strănutați sau tușiți</strong></p>
                <p>Dacă aveți infecție respiratoare acută, evitați apropierea de alte persoane, tușiți cu gura
                    acoperită sau într-un șervețel de preferat de unică folosință, purtați mască de protecție si
                    spălați măinile. Dacă in momentul în care tușiți vă acoperiți gura cu mâinile ,puteți contamina
                    obiecte sau persoane cu care veniți în contact.</p>
                <p><strong>Nu luați medicamente antivirale și nici antibiotice decât în cazul în care vă prescrie
                        medicul </strong></p>
                <p>Momentan, nu există cercetări științifice care evidentiază ca folosirea medicamentelor
                    antivirale, pot preveni infectarea cu noul coronavirus (Covid-19). Antibioticele funcționeaza
                    doar impotriva bacteriilor nu împotriva virusului.</p>
                <p>Covid-19 este un virus, deci nu se utilizează antibiotic ca și metodă de prevenire sau tratament,
                    decât în cazul în care se constată și o infecție bacteriană.</p>
                <p><strong>Curățați toate suprafețele cu dezinfectanți pe bază de clor sau alcool</strong></p>
                <p>Dezinfectanții chimici ce pot ucide noul coronavirus (Covid-19), sunt dezinfectanți ce conțin,
                    clor, înnălbitori, solvent, etanol de 75%, acid paracetic si cloroform. Medicul și farmacistul
                    dumneavoastră vor ști ce să recomande.</p>
                <p><strong>Utilizați mască de protecție doar în cazul în care suspectați că sunteți bolnav sau în
                        cazul în care acordați asistență persoanelor bolnave</strong></p>
                <p>Organizația Mondială a Sănătății, recomandă folosirea măștii de protecție doar în cazul în care
                    suspectați că ați fost contaminat cu noul coronavirus, și prezentați simptome de tuse, strănut,
                    sau în cazul in care acordați asistență unei persoane care este suspectă de a fi infectată cu
                    noul coronavirus. (O calatorie recenta în China sau zonele in carantina din Europa, cu simptome
                    respiratorii).</p>
                <p><strong><em>UTILIZAREA MĂȘTII DE PROTECȚIE &ndash; ajută și limitează răspândirea virusului dar
                            trebuie să fie folosită împreună cu celelalte măsuri de igienă printre care spălarea
                            mâinilor pentru cel puțin 20 de secunde. Nu este necesar a se folosi măști de protecție
                            suprapuse una peste alta.</em></strong></p>
                <p><strong>Produsele MADE in CHINA sau pachetele primite din China nu sunt periculoase</strong></p>
                <p>Organizația Mondial a Sănătății a declarat că persoanele care primesc pachete din China nu se
                    supun nici unui risc de a se contamina cu noul coronavirus, deoarece acesta nu trăieste mult
                    timp pe suprafețe . Până în prezent nu există nici o dovadă că produsele/obiectele produse în
                    China pot transmite noul coronavirus (Covid-19).</p>
                <p><strong>Sunați la 112 dacă aveți febră, tușiți sau v-ați întors din China sau zonele in carantina
                        din Europa de cel puțin 14 zile Perioada de incubație a noului coronavirus, este cuprins
                        intre 1 și 14 zile.</strong></p>
                <p>Daca v-ați întors dintr-o călătorie din China sau zonele in carantina din Europa de mai puțin de
                    14 zile sau ați intrat în contact cu persoane care s-au întors din China sau zonele in carantina
                    din Europa de mai puțin 14 zile și aveți febră, tușiți, prezentați dificultate respiratorie,
                    dureri musculare și stări de oboseală, sunați la 112 pentru a primi informații necesare. Purtați
                    mască de protecție dacă intrați în contact cu alte persoane, folosiți servețele de unică
                    folosință și spală bine mâinile.</p>
                <p><strong>Animalele de companie nu transmit coronavirus</strong></p>
                <p>în acest moment nu există dovezi că animalele de companie, câini și pisici pot fi infectate de
                    virus. în orice caz, trebuie să ne spălăm tot timpul mâinile cu apă și săpun după ce intrăm în
                    contact cu animalele de companie.</p>

                <a href="http://cnscbt.ro/index.php/informatii-pentru-populatie" target="_blank">Informatii pentru
                    populatie</a><a href="http://cnscbt.ro/index.php/sfaturi-pentru-calatori-1" target="_blank">Sfaturi
                    pentru calatori</a><a href="http://cnscbt.ro/index.php/situatia-la-nivel-global-actualizata-zilnic"
                    target="_blank">Situatia la nivel global</a>
            </div>
        </div>
    </div>
</div>